'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  /* Base geometry */\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n\n  /* Center the content */\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: all 0.2s ease;\n\n  /* Default state */\n  svg {\n    transition: transform 0.15s ease;\n  }\n\n  path {\n    transition: fill 0.2s ease;\n    fill: ', ';\n  }\n\n  /* Hovered state */\n  &:hover {\n    background: rgba(0, 0, 0, 0.015);\n    path {\n      fill: ', ';\n    }\n  }\n\n  /* Active state */\n  &:active {\n    background: rgba(0, 0, 0, 0.03);\n    svg {\n      transform: ', ';\n    }\n  }\n\n  ', ';\n\n  ', ';\n'], ['\n  /* Base geometry */\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: ', 'px;\n\n  /* Center the content */\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  cursor: pointer;\n  border: none;\n  outline: none;\n  transition: all 0.2s ease;\n\n  /* Default state */\n  svg {\n    transition: transform 0.15s ease;\n  }\n\n  path {\n    transition: fill 0.2s ease;\n    fill: ', ';\n  }\n\n  /* Hovered state */\n  &:hover {\n    background: rgba(0, 0, 0, 0.015);\n    path {\n      fill: ', ';\n    }\n  }\n\n  /* Active state */\n  &:active {\n    background: rgba(0, 0, 0, 0.03);\n    svg {\n      transform: ', ';\n    }\n  }\n\n  ', ';\n\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      &,\n      &:hover {\n        path {\n          fill: ', ';\n        }\n      }\n    '], ['\n      &,\n      &:hover {\n        path {\n          fill: ', ';\n        }\n      }\n    ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ControlButton = _styledComponents2.default.button(_templateObject, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.theme.darkGrayColor;
}, function (props) {
  return props.theme.textColor;
}, function (props) {
  return props.activeIconTransform || 'none';
}, function (props) {
  return props.toggled && (0, _styledComponents.css)(_templateObject2, function (props) {
    return props.theme.primaryColor;
  });
}, function (props) {
  return props.disabled && '\n    opacity: 0.2;\n    pointer-events: none;\n  ';
});

ControlButton.propTypes = {
  size: _propTypes2.default.number,
  disabled: _propTypes2.default.bool
};

ControlButton.defaultProps = {
  size: 40
};

exports.default = ControlButton;